module.exports = __webpack_public_path__ + "4fe2763a9e4a4efdbed603184b07e338.svg";